import { makeStyles } from '@material-ui/styles';
import React, { FunctionComponent, useCallback, useMemo, useState } from 'react';

import SignalConnectionTelemetryDataPanel from 'src/components/pages/pageElements/videoConference/SignalConnectionTelemetryDataPanel';
import { VideoSignalConnection } from 'src/components/pages/pageElements/videoConference/domain/types';

interface SignalConnectionTelemetryDataPanelGroupProps {
  signalConnections: VideoSignalConnection[];
}

const SignalConnectionTelemetryDataPanelGroup: FunctionComponent<
  SignalConnectionTelemetryDataPanelGroupProps
> = ({ signalConnections }) => {
  const classes = useStyles();
  const [expandedPanel, setExpandedPanel] = useState<string | boolean>(false);

  const handleChange = useCallback(
    connectionId => (event, newExpanded) => {
      setExpandedPanel(newExpanded ? connectionId : false);
    },
    [],
  );

  const validSignalConnections = useMemo(
    () =>
      signalConnections
        // only show data for signalConnections with signalData to display
        .filter(
          signalConnection =>
            signalConnection !== undefined &&
            signalConnection.streamName !== '' &&
            signalConnection.signalData !== undefined,
        ),
    [signalConnections],
  );

  return (
    <div id="patientTelemetryPanelGroup" className={classes.panelGroup}>
      {validSignalConnections.map(signalConnection => (
        <SignalConnectionTelemetryDataPanel
          telemetryData={signalConnection?.signalData?.telemetry}
          connectionId={signalConnection.connectionId}
          lastUpdated={signalConnection.lastUpdated}
          handleChange={handleChange}
          expanded={expandedPanel}
        />
      ))}
    </div>
  );
};

const useStyles = makeStyles({
  panelGroup: {
    position: 'absolute' as const,
    top: 0,
    left: 0,
    zIndex: 2,
  },
});

export default SignalConnectionTelemetryDataPanelGroup;
